import { useQuery } from '@tanstack/react-query';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { parseTableMetadata, withDefaultName } from '../types';

export const TABLES_QUERY = ['@MDH', 'getTablesApiV2TableGet'] as const;

export const useTables = () => {
  return useQuery({
    queryKey: TABLES_QUERY,
    queryFn: () =>
      datasetApi.getDatasetsApiV2DatasetsGet(
        { limit: 1000 },
        getDatasetRequestConfig()
      ),
    select: res =>
      res.data.results.map(parseTableMetadata).map(withDefaultName),
  });
};
